import { Components } from "@thisgorilla/primate-ds";
import { IconsProps } from "@thisgorilla/primate-ds/dist/Icons";
import styled, { useTheme } from "styled-components";
import { FlexColumn, FlexRowCenter } from "../../../../Common/Styles";
import { PeopleYouMightKnow } from "./PeopleYouMightKnow";

type Props = {
  title: string;
  iconType: IconsProps.IconTypes;
};
export const useFollowersFollowingEmptyState = ({ title, iconType }: Props) => {
  const { typography } = useTheme();

  return () => (
    <Container>
      <Wrapper>
        <Title $gapInPx={8}>
          <Components.Icon type={iconType} size="16px" />
          <Components.Text
            text={title}
            style={{ tokenStyle: typography.Heading.S }}
            lineHeight="line-height-400"
            letterSpacing="letter-spacing-100"
            fontWeight="font-weight-semibold"
          />
        </Title>
        <Components.Text
          text="Look up top industry voices, colleagues, friends or family to follow."
          style={{ tokenStyle: typography.Body.M }}
          letterSpacing="letter-spacing-100"
        />
        <PeopleYouMightKnow />
      </Wrapper>
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => `
  box-shadow: ${theme.boxShadows["box-shadow-m"]};
  border-radius: ${theme.radius["radius-m"].value}rem;
  padding: ${theme.spacing["spacing-2"].value}rem;
  background: linear-gradient(to right, ${theme.Color.elevation.surface["surface-secondary"].value}, ${theme.Color.background.neutral.default.value});
`
);
const Wrapper = styled(FlexColumn)(
  ({ theme }) => `
  background: ${theme.Color.background.neutral.subtle.default.value};
  border-radius: ${theme.radius["radius-m"].value}rem;
  padding: ${theme.spacing["spacing-4"].value}rem;
`
);
const Title = styled(FlexRowCenter)`
  justify-content: start;
`;
